<div class="signin" [ngClass]="{'show' : data.focusLogin === true}">
  <app-login (close)="onLoginSuccess()"></app-login>
</div>
<div class="create" [ngClass]="{'show' : data.focusLogin === false}">
  <app-register (close)="onRegisterSuccess()"></app-register>
</div>